export const INVITEE_AUTHORIZED = 'INVITEE_AUTHORIZED';
export const INVITEE_REGION_UPDATED = 'INVITEE_REGION_UPDATED';
export const INVITEE_EVENTS_UPDATED = 'INVITEE_EVENTS_UPDATED';
export const INVITEE_INVITATION_UPDATED = 'INVITEE_INVITATION_UPDATED';
export const INVITEE_NAMES_UPDATED = 'INVITEE_NAMES_UPDATED';
export const INVITEE_ID_UPDATED = 'INVITEE_ID_UPDATED';
export const INVITEE_BA_UPDATED = 'INVITEE_BA_UPDATED';
export const INVITEE_ATTENDEES_UPDATED = 'INVITEE_ATTENDEES_UPDATED';
export const INVITEE_RESET = 'INVITEE_RESET';

export const BRYCEN_CLICKED = 'BRYCEN_CLICKED';
export const JILLIAN_CLICKED = 'JILLIAN_CLICKED';
export const WEDDING_DATE_CLICKED = 'WEDDING_DATE_CLICKED';

export const ADMIN_TOGGLED = 'ADMIN_TOGGLED';
export const ADMIN_CLICKED = 'ADMIN_CLICKED';

export const WEDDING_DATE_SET = 'WEDDING_DATE_SET';
export const PRECEPTION_DATE_SET = 'PRECEPTION_DATE_SET';

export const VIEW_INVITATION_CLICKED = 'VIEW_INVITATION_CLICKED';

export const KONAMI_TOGGLED = 'KONAMI_TOGGLED';
export const CODE_TOGGLED = 'CODE_TOGGLED';

export const COUNTDOWN_CHANGED = 'COUNTDOWN_CHANGED';

export const PHOTO_URLS_FETCHED = 'PHOTO_URLS_FETCHED';



// WEBPACK FOOTER //
// ./src/actions/actionTypes.js